import { useCallback, useEffect, useState } from 'react';
import {
  ShipmentNotificationRecipientData,
  shipmentNotificationRecipient,
} from '@/apis/shipment';
import { useToken } from '@/common/helper';
import useUnauthorize from '@/hooks/useUnauthorize';

interface UseFetchGeoFenceRecipientsReturn {
  recipientData?: ShipmentNotificationRecipientData;
  refetchGeoFenceRecipients: () => void;
}

const useFetchGeoFenceRecipients = (
  shipmentId: string
): UseFetchGeoFenceRecipientsReturn => {
  const { checkTokenExpiry } = useToken();
  const { unauthorize } = useUnauthorize();
  const [recipientData, setRecipientData] = useState<
    ShipmentNotificationRecipientData | undefined
  >(undefined);

  const fetchRecipientData = useCallback((): void => {
    const token = checkTokenExpiry();
    if (!token) return;

    shipmentNotificationRecipient(token, shipmentId)
      .then((res) => {
        const data = res?.data?.data ?? null;
        setRecipientData(data?.is_success ? data?.data : undefined);
      })
      .catch((error) => {
        unauthorize(error);
        setRecipientData(undefined);
      });
  }, [checkTokenExpiry, shipmentId, unauthorize]);

  useEffect(() => {
    fetchRecipientData();
  }, [fetchRecipientData]);

  return { recipientData, refetchGeoFenceRecipients: fetchRecipientData };
};

export default useFetchGeoFenceRecipients;
